import { render, staticRenderFns } from "./Facesheet.vue?vue&type=template&id=b9ab053c&scoped=true&"
import script from "./Facesheet.vue?vue&type=script&lang=js&"
export * from "./Facesheet.vue?vue&type=script&lang=js&"
import style0 from "./Facesheet.vue?vue&type=style&index=0&id=b9ab053c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ab053c",
  null
  
)

export default component.exports